import React from 'react';
import About from '../components/About';

const AboutPage = () => {
  return (
    <div className="container">
      <div className="page-section animate-fade-in-up animate-stagger">
        <About />
      </div>
    </div>
  );
};

export default AboutPage;
